@if(score?.success)
{
  <div class="score-container">  
    <span class="score {{score.likelihood}}">
      <span class="indicator"></span>
      <span class="score-value">{{ score.score * 100 | number : '1.2-2' }}%</span>
    </span>
    <span class="description">{{('Debtor.BankruptcyScore.Description.' + score.likelihood) | translate}}</span>
    <span class="provider">
      <span class="provider-text">Powered by </span><i></i>
    </span>
  </div>
}

@if(!score?.success)
{
  <div class="score-container">  
    <span>{{'Debtor.BankruptcyScore.Unavailable' | translate}}</span>
  </div>
}